// workaround to reduce frequency of toasting on the same error
export function newTimeWindowMemo<K = any, T = any>(msTTL: number) {
  const memoMap = new Map<K, { value: T; timestamp: number }>();
  const checkInterval = msTTL / 2;

  const timerId = setInterval(() => {
    for (const [key, { timestamp }] of memoMap.entries()) {
      const expired = Date.now() - timestamp > msTTL;
      if (expired) memoMap.delete(key);
    }
  }, checkInterval);

  const has = (key: K) => memoMap.has(key);
  const get = (key: K) => memoMap.get(key);
  const set = (key: K, value: T) => {
    memoMap.set(key, { value, timestamp: Date.now() });
  };
  const add = (key: K) => set(key, null!);
  // calling stopTimer if necessary
  const stopTimer = () => {
    clearInterval(timerId);
  };
  return { has, get, set, add, stopTimer };
}
